import { useState } from 'react';
import { Marca } from '../componentes/Marca.js';
import { Botao } from '../componentes/ui/Botao.js';
import { useSessao } from '../auth/SessaoContexto.js';
import { ApiError } from '../api/cliente.js';

export function Login() {
  const { entrar } = useSessao();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function submeter(e: React.FormEvent) {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await entrar(email, senha);
    } catch (err) {
      setErro(
        err instanceof ApiError ? err.mensagem : 'Não foi possível entrar. Tente novamente.',
      );
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="grid min-h-dvh place-items-center bg-fundo p-4">
      <div className="w-full max-w-[400px]">
        <div className="mb-8 flex justify-center">
          <Marca tamanho="grande" />
        </div>

        <form
          onSubmit={submeter}
          className="rounded-card border border-borda bg-superficie p-7"
        >
          <h1 className="text-[17px] font-extrabold">Entrar no painel</h1>
          <p className="mt-1 text-[13px] text-texto-suave">
            Gerenciamento de DNS reverso
          </p>

          <label className="mt-6 block">
            <span className="mb-1.5 block text-[11px] font-bold uppercase tracking-[0.6px] text-texto-suave">
              E-mail
            </span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              autoComplete="username"
              className="h-11 w-full rounded-controle border border-borda px-3 text-[14px]
                focus:border-marca focus:outline-none"
            />
          </label>

          <label className="mt-4 block">
            <span className="mb-1.5 block text-[11px] font-bold uppercase tracking-[0.6px] text-texto-suave">
              Senha
            </span>
            <input
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
              autoComplete="current-password"
              className="h-11 w-full rounded-controle border border-borda px-3 text-[14px]
                focus:border-marca focus:outline-none"
            />
          </label>

          {erro && (
            // role=alert para o leitor de tela anunciar sem o usuário precisar
            // procurar a mensagem.
            <p
              role="alert"
              className="mt-4 rounded-chip bg-erro-fundo px-3 py-2 text-[12.5px] font-semibold text-erro"
            >
              {erro}
            </p>
          )}

          <Botao
            type="submit"
            variante="primario"
            carregando={enviando}
            className="mt-6 w-full"
          >
            Entrar
          </Botao>
        </form>
      </div>
    </div>
  );
}
